<template>

    <h3 v-if="['1', 1, true, 'true', 'TRUE'].includes(store?.state?.form?.data?.show_intro_block ?? false)">
        {{ currentPage.title }}</h3>


    <div v-if="totalGroupCount > 1">page {{ currentGroupIndex }} / {{ totalGroupCount }}</div>

    <form-fields-group
        v-for="field in currentPage.fields"
        :key="field.key"
        ref="currentFields"
        :field="field">


    </form-fields-group>

    <button
        type="button"
        class="btn btn-submit"
        v-if="currentGroupIndex > 1"> {{ copydeck.btn_prev }}
    </button>

    <button
        type="button"
        class="btn btn-submit"
        v-if="currentGroupIndex < totalGroupCount"> {{ copydeck.btn_next }}
    </button>

    <button
        type="submit"
        class="btn btn-submit"
        @click.prevent="submit"
        v-if="!submitting && currentGroupIndex >= totalGroupCount"> {{ copydeck.btn_submit }}
    </button>

    <div v-if="submitting" class="during-submit-message">
        <span class="ajax-loader-container">
           <span class="ajax-loader on-the-left"></span>
        </span>
        <span class="submitting-message" v-html="  copydeck.submittingMessage "></span>
    </div>

</template>

<script>
export default {
    name: "FormPage",
}
</script>

<script setup>

import {
    computed,
    nextTick,
    onMounted,
    ref,
} from "vue";
import { useStore } from "vuex";
import useCopydeck from "../composables/UseCopydeck"
import FormFieldsGroup from "./FormFieldsGroup.vue";
import useStripe from "../composables/useStripe";
import { smoothScrollToElement } from "../../Utils.js";

const store    = useStore();
const copydeck = useCopydeck();


const emits = defineEmits( [ "submitted" ] );

let loadStripe = store.state.form.data.use_stripe == 1;
const stripe   = loadStripe ? useStripe() : null;


let currentGroupIndex = computed( () => store.state.currentGroup + 1 );
let totalGroupCount   = computed( () => store.state.totalGroup );
let currentPage       = computed( () => store.state.form.data.groups[ store.state.currentGroup ] );

let isLastGroup   = computed( () => currentGroupIndex.value >= totalGroupCount.value );
let submitting    = ref( false );
let currentFields = ref( [] );

function hydrateField( key, value )
{
    let currentField = currentFields.value.find( f => f.getKey() === key );
    currentField.setValue( value );
}

function getDatas()
{
    let arrData = currentFields.value.map( f => f.getData() );
    return arrData;
}

function setErrors( errors )
{
    for ( let strKey in errors ) {
        let fieldIndex = currentFields.value.findIndex( f => f.getKey() === strKey );
        let field      = currentFields.value[ fieldIndex ];

        if ( field ) {
            field.setError( errors[ strKey ] );
        }
        else {
            //this might be in another page/group. unlikely, but possible
        }



    }


    nextTick( () => {
        const firstError = document.querySelector( '.input-group.has-errors' );

        if ( firstError ) {
            smoothScrollToElement( firstError );
        }
    } )
}

async function submit()
{

    submitting.value = true;

    let data     = getDatas();
    let response = await store.dispatch( "validate", data );

    if ( response.success ) {

        let stripeResponse;

        if ( loadStripe ) {
            let { createIntent, process, getErrorFromStripe } = stripe;


            let amount     = data.find( d => d.field === "montant" ).value; //NOTE FUTURE PROGRAMMER - THE FORM FIELD MUST BE NAME "montant" - Martin T. 2024-09-25
            stripeResponse = await createIntent( amount );


            if ( !stripeResponse.success ) {

                setErrors( stripeResponse.errors );
                submitting.value = false;
                return;
            }

            let paymentResponse = await process();

            if ( paymentResponse.error ) {
                let { message, category } = getErrorFromStripe( paymentResponse.error, copydeck );

                currentFields.value.forEach( f => f.clearError() );

                let fieldIndex = currentPage.value.fields.findIndex( f => f.type === category );

                let field = currentFields.value[ fieldIndex ];
                field.setError( [ message ] );


                submitting.value = false;


                return;
            }
        }


        store.commit( "datastore", data );
        let response = await store.dispatch( "submit", store.state.datastore );

        if ( response.success ) {
            emits( "submitted" );


        }
        else //this should never happens, but we never know
        {
            setErrors( response.errors );
        }
    }
    else {
        setErrors( response.errors );
    }

    submitting.value = false;

}

defineExpose( { hydrateField } )


if ( loadStripe ) {
    let { activate } = stripe;

    onMounted( async () =>
               {
                   await activate( "#form-stripe-credit-card-number", "#form-stripe-credit-card-expiry-date", "#form-stripe-credit-card-ccv" );
               } )
}
</script>
